/** @jsxImportSource @emotion/react */
import React from "react";
import { PlaceholderBody } from "./PlaceholderBody";
import { SerializedStyles, css } from "@emotion/react";
import { colors } from "./colors";
import { effects } from "./effects";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode;
  header: string;
  subHeader: string;
  additionalStyles?: SerializedStyles;
}

export const PlaceholderBox = ({
  icon,
  header,
  subHeader,
  additionalStyles,
  ...rest
}: Props) => {
  const placeholderBoxStyle = css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    background: ${colors.buttonPrimaryWhite};
    box-shadow: ${effects.buttonPrimary};
    border-radius: 8px;
    width: 100%;
    padding: 24px;
    ${additionalStyles}
  `;
  return (
    <div css={placeholderBoxStyle} {...rest}>
      <PlaceholderBody icon={icon} header={header} subHeader={subHeader} />
    </div>
  );
};
